/** Index of the band containing the ratio, clamped to the first and last band, or null when the ratio is not finite. */
export function findPerformanceBandIndex(
  ratio: number | null | undefined,
  bands: readonly { from: number; to: number }[]
): number | null {
  if (ratio == null || !Number.isFinite(ratio) || bands.length === 0) {
    return null;
  }

  for (let i = bands.length - 1; i >= 0; i--) {
    if (ratio >= bands[i].from) return i;
  }
  return 0;
}
